<template>
  <v-dialog v-model="dialogOpen" width="800">
    <v-card>
      <v-card-title class="text-h5 primary white--text d-flex flex-nowrap justify-space-between align-center">
        {{ $t('guide.firstStepTitle') }}
        <v-btn icon dark @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-4">
        <div class="black--text text-body-1 mb-2">
          <h6 class="text-h6 mb-3">{{ $t('guide.ddsDashboard.title') }}</h6>
          <p>
            {{ $t('guide.ddsDashboard.alreadyHaveFarm') }}<br />
            {{ $t('guide.ddsDashboard.description') }}
          </p>
        </div>
        <v-checkbox v-model="hideDialogInFuture" :label="$t('guide.dontShowAgain')"></v-checkbox>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn outlined color="primary" @click="closeDialog">{{ $t('dueDiligence.close') }}</v-btn>
        <v-btn depressed color="primary" :to="{ name: 'createDueDiligenceReports' }">{{ $t('guide.ddsDashboard.createNewReport') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  import { isDdsExporter } from "@/utils";
  
  export default {
    data() {
      return {
        dialog: true, // default open unless rules say otherwise
        hideDialogInFuture: false,
      };
    },
  
    computed: {
      dialogOpen: {
        get() {
          
          if (isDdsExporter()) {
            return false;
          }
          const hideGuide = localStorage.getItem("hideDDSDashboardGuide");
  
          // If user chose "don't show again"
          if (hideGuide === "true") {
            return false;
          }
  
          return this.dialog;
        },
  
        set(value) {
          this.dialog = value;
        }
      }
    },
  
    mounted() {
      // Sync checkbox state with localStorage
      this.hideDialogInFuture =
        localStorage.getItem("hideDDSDashboardGuide") === "true";
    },
  
    methods: {
      closeDialog() {
        if (this.hideDialogInFuture) {
          localStorage.setItem("hideDDSDashboardGuide", "true");
        }
  
        this.dialog = false;
      }
    }
  };
  </script>
